// extracted by mini-css-extract-plugin
module.exports = {"root":"pdf-view_root__5BKtE","frame":"pdf-view_frame__4pY4W"};